const accents = [
  'var(--color-scheme-accent-1)',
  'var(--color-scheme-accent-2)',
  'var(--color-scheme-accent-3)',
  'var(--color-scheme-accent-4)',
]

// A group only needs the random accent if a descendant actually reads it on group hover.
const groupSelector = CSS.supports('selector(:has(*))')
  ? '.group:has([class*="group-hover"][class*="scheme-accent"], .theme-button--in-group)'
  : '.group'

const accentSelector = [
  '[class*="hover:text-scheme-accent"]',
  '[class*="hover:bg-scheme-accent"]',
  '[class*="hover:border-scheme-accent"]',
]
  .map((selector) => selector + ':not([class*="group-hover"])')
  .concat(groupSelector)
  .join(',')

// Theme buttons and rich text links read the accent from CSS variables instead of a utility class.
const controlSelector = 'a[href], button, [role="button"], input[type="submit"]'

let activeTrigger = null
let restoreAccent = ''
let previousAccent = ''

function activateRandomAccent(trigger) {
  const candidates = accents.filter((accent) => accent !== previousAccent)

  previousAccent = candidates[(Math.random() * candidates.length) | 0]
  restoreAccent = trigger.style.getPropertyValue('--color-scheme-accent')

  trigger.style.setProperty('--color-scheme-accent', previousAccent)
  activeTrigger = trigger
}

function deactivateRandomAccent() {
  if (restoreAccent) {
    activeTrigger.style.setProperty('--color-scheme-accent', restoreAccent)
  } else {
    activeTrigger.style.removeProperty('--color-scheme-accent')
  }

  activeTrigger = null
}

document.addEventListener(
  'pointerover',
  (event) => {
    if (event.pointerType === 'touch') return

    const target = event.target
    if (!(target instanceof Element)) return

    const trigger =
      target.closest(accentSelector) || target.closest(controlSelector)

    if (!trigger || trigger === activeTrigger) return

    if (activeTrigger) deactivateRandomAccent()
    activateRandomAccent(trigger)
  },
  { passive: true }
)

document.addEventListener(
  'pointerout',
  (event) => {
    if (!activeTrigger || activeTrigger.contains(event.relatedTarget)) return

    deactivateRandomAccent()
  },
  { passive: true }
)
